import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { FullScreenLoading } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { useGetEmployerBySlugQuery } from '@backrs_ui/grow-ui/src/redux/employer/employer.api';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import { resetMakeItPersonal } from '@backrs_ui/grow-ui/src/redux/makeItPersonal/makeItPersonal';

import { EmployerPage } from './EmployerPage';

export const EmployerPageContainer = () => {
  const { employerSlug } = useParams();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {
    data: foundEmployer,
    isLoading,
    error,
  } = useGetEmployerBySlugQuery(employerSlug || '', {
    skip: !employerSlug,
  });

  useEffect(() => {
    if (!employerSlug || error) {
      navigate(APP_ROUTE.NOT_FOUND_404); // replace this with the employer search page when built!

      return;
    }

    return () => {
      dispatch(resetMakeItPersonal());
    };
  }, [navigate, employerSlug, dispatch, error]);

  if (!employerSlug || isLoading || !foundEmployer || error) {
    return <FullScreenLoading />;
  }

  return <EmployerPage employer={foundEmployer} />;
};
